import moment from "moment";
import React, { useState } from "react";
import * as Styles from "./styles/MyAccountContainerStyles";
import { Button, Grid, Typography } from "@material-ui/core";
import { IBidder } from "../../interfaces/bidders/IBidder";
import { LoginHistoryTable } from "./LoginHistoryTable";

export const LoginHistory: React.FC<{ bidder: IBidder }> = ({
  bidder
}) => {
  const [showAll, setShowAll] = useState<boolean>(false);

  const classes = Styles.MyAccountContainerStyles();

  const lastLoginDate = moment(bidder.lastLogin);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.lastLoginText}>
          Your Last Login: {lastLoginDate.format('HH:mma DD/MM/YY')} | {bidder.lastLoginIP ?? 'Unknown'}
        </Typography>
      </Grid>

      {!showAll && (
        <Grid item xs={12} style={{ marginTop: '1rem' }}>
          <Button variant="contained" color="primary" onClick={() => setShowAll(true)}>
            View all history
          </Button>
        </Grid>
      )}

      {showAll && (
        <LoginHistoryTable/>
      )}
    </Grid>
  );
};
